import { ChatMiddlewareType } from '@indigohive/cogfy-types'
import { siAmazonwebservices, siOpenai, siWhatsapp, SimpleIcon as SimpleIconType, siX, siGooglegemini, siAnthropic, siSentry } from 'simple-icons'
import { createElement } from 'react'
import {
  ArrowDownWideNarrowIcon,
  ArrowUpWideNarrowIcon,
  AudioLinesIcon,
  Bird,
  BrainIcon,
  CalendarClock,
  CircleStopIcon,
  DatabaseIcon,
  FolderTreeIcon,
  GaugeIcon,
  GlobeIcon,
  HammerIcon,
  HistoryIcon,
  IterationCwIcon,
  ReplyIcon,
  ScrollTextIcon,
  ShieldAlertIcon,
  ShieldXIcon,
  SpeechIcon,
  SquareTerminalIcon,
  TextSearchIcon,
  ZapIcon
} from 'lucide-react'
import { SimpleIcon } from '../SimpleIcon'

export type ChatMiddlewareIconProps = {
  type: ChatMiddlewareType
  size?: number
}

const CHAT_MIDDLEWARE_LUCIDE_ICONS: Partial<Record<ChatMiddlewareType, typeof SquareTerminalIcon>> = {
  'cogfy.collectionRetrieval': TextSearchIcon,
  consensus: ZapIcon,
  'cpqdAsr.generateSpeech': SpeechIcon,
  downstreamFallback: ArrowDownWideNarrowIcon,
  echo: IterationCwIcon,
  'elevenLabs.generateSpeech': SpeechIcon,
  errorHandler: ShieldAlertIcon,
  filterOutput: ShieldXIcon,
  rateLimiting: GaugeIcon,
  reply: ReplyIcon,
  transcribeAudio: AudioLinesIcon,
  generateSpeech: SpeechIcon,
  'lemonfox.generateSpeech': SpeechIcon,
  'lemonfox.transcribeAudio': AudioLinesIcon,
  'hamsa.generateSpeech': SpeechIcon,
  'hamsa.transcribeAudio': AudioLinesIcon,
  http: GlobeIcon,
  group: FolderTreeIcon,
  maritaca: Bird,
  persist: DatabaseIcon,
  scheduleMessage: CalendarClock,
  stop: CircleStopIcon,
  instructions: ScrollTextIcon,
  history: HistoryIcon,
  retrieval: TextSearchIcon,
  'typesense.retrieval': TextSearchIcon,
  tool: HammerIcon,
  upstreamFallback: ArrowUpWideNarrowIcon,
  groq: BrainIcon
}

const CHAT_MIDDLEWARE_SIMPLE_ICONS: Partial<Record<ChatMiddlewareType, SimpleIconType>> = {
  anthropic: siAnthropic,
  bedrock: siAmazonwebservices,
  'bedrock.router': siAmazonwebservices,
  'bedrock.generateStandaloneQuestion': siAmazonwebservices,
  googleAIStudio: siGooglegemini,
  grok: siX,
  openai: siOpenai,
  'openai.generateStandaloneQuestion': siOpenai,
  'openai.router': siOpenai,
  sentry: siSentry,
  whatsapp: siWhatsapp
}

const CHAT_MIDDLEWARE_PUBLIC_ICONS: Partial<Record<ChatMiddlewareType, string>> = {
  azure: '/azure-blackwhite-avatar.webp',
  deepseek: '/deepseek-avatar.webp',
  mcpTools: '/modelcontextprotocol-avatar.webp'
}

export function ChatMiddlewareIcon (props: ChatMiddlewareIconProps) {
  const { type, size = 16 } = props

  if (CHAT_MIDDLEWARE_LUCIDE_ICONS[type]) {
    return createElement(CHAT_MIDDLEWARE_LUCIDE_ICONS[type], { size })
  }

  if (CHAT_MIDDLEWARE_SIMPLE_ICONS[type]) {
    return <SimpleIcon icon={CHAT_MIDDLEWARE_SIMPLE_ICONS[type]} size={size} />
  }

  if (CHAT_MIDDLEWARE_PUBLIC_ICONS[type]) {
    return <img src={CHAT_MIDDLEWARE_PUBLIC_ICONS[type]} alt={type} width={size} height={size} />
  }

  return (
    <></>
  )
}
